import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSubjectsDataGridFilter } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import {
  dataGridNumberSorter,
  dataGridDateSorter,
  dataGridTextSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { Spinner } from '../../../../common/index.jsx';
import dayjs from 'dayjs';
import { isNull } from 'lodash';

const AttendanceOverviewTable = ({ subjects, attendanceEvents }) => {
  const { t } = useTranslation();
  const subjectsFilterProps = useSubjectsDataGridFilter(
    'subject_id',
    !isNull(subjects) ? subjects : [],
  );
  const titleTextFilterProps = useDataGridTextFilter('person_id.last_name');

  const daysInWeek = {
    1: 'Pondelok',
    2: 'Utorok',
    3: 'Streda',
    4: 'Štvrtok',
    5: 'Piatok',
  };

  const columns = useMemo(
    () => [
      {
        title: t('Meno'),
        dataIndex: ['person_id', 'full_name'],
        ellipsis: true,
        ...titleTextFilterProps,
      },
      {
        title: t('Udalosť'),
        dataIndex: 'subject',
        ellipsis: true,
        ...subjectsFilterProps, // includes render
      },
      {
        title: t('Body'),
        dataIndex: 'points',
        ellipsis: true,
        sorter: dataGridNumberSorter('points'),
      },
      {
        title: t('Dátum'),
        dataIndex: 'started_at',
        ellipsis: true,
        render: (started) =>
          `${dayjs(started).format('DD.MM.YYYY')} (${daysInWeek[dayjs(started).get('day')]})`,
        sorter: dataGridDateSorter('started_at'),
        defaultSortOrder: 'ascend',
        ...titleTextFilterProps,
      },
      {
        title: t('Čas'),
        dataIndex: 'started_at',
        ellipsis: true,
        render: (_, record) => {
          return `${dayjs(record.started_at).format('HH:mm')} - ${dayjs(record.ended_at).format('HH:mm')}`;
        },
        ...titleTextFilterProps,
      },
    ],
    [t, titleTextFilterProps],
  );

  return (
    <DataGrid
      rowKey={(event) => event.id}
      columns={columns}
      dataSource={attendanceEvents || []}
      permissionsBasic={'attendance.index'}
      sorter={dataGridDateSorter('started_at')}
      disableSettings={true}
    />
  );
};

AttendanceOverviewTable.propTypes = {
  attendanceEvents: PropTypes.array,
};

export default AttendanceOverviewTable;
